import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './TrustSection.css';

const icons = {
  audit: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  hash: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="9" x2="20" y2="9" />
      <line x1="4" y1="15" x2="20" y2="15" />
      <line x1="10" y1="3" x2="8" y2="21" />
      <line x1="16" y1="3" x2="14" y2="21" />
    </svg>
  ),
  dsar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
      <circle cx="12" cy="7" r="4" />
      <line x1="18" y1="8" x2="23" y2="13" />
      <line x1="23" y1="8" x2="18" y2="13" />
    </svg>
  ),
  human: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  optout: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M4.93 4.93l14.14 14.14" />
    </svg>
  ),
  score: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  learn: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2a4 4 0 014 4c0 2-2 3-2 5h-4c0-2-2-3-2-5a4 4 0 014-4z" />
      <line x1="10" y1="14" x2="14" y2="14" />
      <line x1="10" y1="17" x2="14" y2="17" />
      <path d="M10 20h4" />
    </svg>
  ),
  compliance: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
};

const TrustSection = () => {
  const { language } = useLanguage();
  const t = translations[language].trustSection;
  const [labelRef, labelVisible] = useScrollAnimation({ threshold: 0.2 });
  const [gridRef, gridVisible] = useScrollAnimation({ threshold: 0.05 });
  return (
    <section className="trust-section">
      <div className="trust-section-bg">
        <img src="./img/sg_image.jpg" alt="" />
      </div>
      <div className="trust-section-inner">
        <div
          ref={labelRef}
          className={`trust-section-header scroll-fade-in ${labelVisible ? 'is-visible' : ''}`}
        >
          <div className="trust-section-lock-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0110 0v4" />
              <circle cx="12" cy="16" r="1" />
            </svg>
          </div>
          <span className="section-label">{t.label}</span>
          <h2 className="trust-section-title">{t.title}</h2>
          <p className="trust-section-subtitle">{t.subtitle}</p>
        </div>

        <div
          ref={gridRef}
          className="trust-section-grid"
        >
          {t.badges.map((badge, i) => (
            <div
              key={i}
              className={`trust-section-card ${badge.size === 'wide' ? 'trust-section-card--wide' : ''} scroll-fade-in-stagger ${gridVisible ? 'is-visible' : ''}`}
            >
              <div className="trust-section-card-top">
                <div className="trust-section-card-icon">
                  {icons[badge.icon]}
                </div>
                <div className="trust-section-card-titles">
                  <h3 className="trust-section-card-title">{badge.title}</h3>
                  {badge.tag && <span className="trust-section-card-tag">{badge.tag}</span>}
                </div>
              </div>
              <p className="trust-section-card-desc">{badge.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TrustSection;
